import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportComponent } from './report/report.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';

const routes: Routes = [
  {
    path:'reports', component:ReportComponent,
    canActivate: [PermissionGuard],
          data: { roles: ['admin','Managment'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReferalRoutingModule { }
